module.exports = __webpack_public_path__ + "img/full5-min.af95033d.png";